import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';
import { TokenService } from '../services/token.service';

export const adminGuard = (): boolean => {
  const router = inject(Router);
  const storage = inject(StorageService);
  const tokenService = inject(TokenService);

  const token = storage.get('access_token');
  const userStr = storage.get('user');

  if (!token || !userStr) {
    router.navigate(['/'], { replaceUrl: true });
    return false;
  }

  // Token expirado — redirecionar para login
  if (tokenService.isTokenExpired()) {
    router.navigate(['/'], { replaceUrl: true });
    return false;
  }

  try {
    const user = JSON.parse(userStr);
    // Admins e superadmins têm acesso às rotas /sadashboard/admin/*
    if (user.user_type === 'admin' || user.user_type === 'superadmin') {
      return true;
    }
    router.navigate(['/sadashboard'], { replaceUrl: true });
    return false;
  } catch {
    router.navigate(['/'], { replaceUrl: true });
    return false;
  }
};
